module.exports = __webpack_public_path__ + "07de38eed48a36cc0a4449e021e442c7.MP3";